import styled from "styled-components";

export const AvatarCroperDiv = styled.div`
  & .ant-upload.ant-upload-select-picture-card {
    height: 140px;
    max-width: 640px;
    width: 100%;
    & .label-upload {
      font-size: ${(props) => props.theme.font.size};
      & > p:first-of-type {
        color: ${(props) => props.theme.colors.text};
        & > span {
          color: ${(props) => props.theme.colors.primary};
        }
      }
      & > p:last-child {
        color: ${(props) => props.theme.colors.textMuted};
      }
    }
  }
  & .ant-upload-list-picture-card-container {
    height: 140px;
    max-width: 640px;
    width: 100%;
  }
  & .ant-upload-list-item-info:before {
    left: 0;
  }
  & a[title="Preview file"] {
    margin-right: 3em;
  }
`;
